export const INTERSTITIALS_FULFILLED = 'waitrose/interstitials/INTERSTITIALS_FULFILLED';
export const INTERSTITIALS_PENDING = 'waitrose/interstitials/INTERSTITIALS_PENDING';
export const INTERSTITIALS_REJECTED = 'waitrose/interstitials/INTERSTITIALS_REJECTED';
export const INTERSTITIALS_UPDATED = 'waitrose/interstitials/INTERSTITIALS_UPDATED';
